import React, { Suspense } from 'react';
import Loading from 'react-simple-loading';

import styles from './styles.css';


function WaitingComponent(Component) {
  /*  eslint-disable-next-line */
  return props => (
    <Suspense
      fallback={
        <div className={styles.loader}>
          <Loading />
        </div>
      }
    >
      <Component {...props} />
    </Suspense>
  );
}

export default WaitingComponent;
